var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'InvoiceList'
      }
    }
  }, [_vm._v("發票列表 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("發票明細")])], 1)], 1)])]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('div', {
    staticClass: "row mb-2 align-items-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-2"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("發票明細")])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('b-form-group', {
    attrs: {
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "會員名稱"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.invoice.customer_name,
      callback: function callback($$v) {
        _vm.$set(_vm.invoice, "customer_name", $$v);
      },
      expression: "invoice.customer_name"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "發票號碼"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "10"
    },
    model: {
      value: _vm.invoice.invoice_number,
      callback: function callback($$v) {
        _vm.$set(_vm.invoice, "invoice_number", $$v);
      },
      expression: "invoice.invoice_number"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.invoice.invoice_number.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "發票狀態"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.invoiceStatusOptions
    },
    model: {
      value: _vm.invoice.invoice_status,
      callback: function callback($$v) {
        _vm.$set(_vm.invoice, "invoice_status", $$v);
      },
      expression: "invoice.invoice_status"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "發票開立日期"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.invoice.invoice_date,
      callback: function callback($$v) {
        _vm.$set(_vm.invoice, "invoice_date", $$v);
      },
      expression: "invoice.invoice_date"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "發票作廢日期"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.invoice.invoice_cancelled_at,
      callback: function callback($$v) {
        _vm.$set(_vm.invoice, "invoice_cancelled_at", $$v);
      },
      expression: "invoice.invoice_cancelled_at"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "隨機碼"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "4"
    },
    model: {
      value: _vm.invoice.random,
      callback: function callback($$v) {
        _vm.$set(_vm.invoice, "random", $$v);
      },
      expression: "invoice.random"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "col-4"
  }, [_c('b-form-group', {
    attrs: {
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "金額"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.invoice.total_price,
      callback: function callback($$v) {
        _vm.$set(_vm.invoice, "total_price", $$v);
      },
      expression: "invoice.total_price"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "年份"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.invoice.invoice_year,
      callback: function callback($$v) {
        _vm.$set(_vm.invoice, "invoice_year", $$v);
      },
      expression: "invoice.invoice_year"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "期別"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.invoice.invoice_period,
      callback: function callback($$v) {
        _vm.$set(_vm.invoice, "invoice_period", $$v);
      },
      expression: "invoice.invoice_period"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "建檔日期"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.invoice.created_at,
      callback: function callback($$v) {
        _vm.$set(_vm.invoice, "created_at", $$v);
      },
      expression: "invoice.created_at"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "發票種類"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.invoiceTypesOptions
    },
    model: {
      value: _vm.invoice.invoice_type,
      callback: function callback($$v) {
        _vm.$set(_vm.invoice, "invoice_type", $$v);
      },
      expression: "invoice.invoice_type"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "發票來源"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.invoiceSourceOptions
    },
    model: {
      value: _vm.invoice.invoice_source,
      callback: function callback($$v) {
        _vm.$set(_vm.invoice, "invoice_source", $$v);
      },
      expression: "invoice.invoice_source"
    }
  })], 1)], 1)], 1)]), _c('div', {
    staticClass: "row mt-4 mb-2 align-items-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-2"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("發票明細")])])]), !_vm.isReadOnly ? _c('div', {
    staticClass: "text-right"
  }, [_c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 ml-2 py-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.addItemHandler
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("新增明細 ")])], 1) : _vm._e(), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.invoice.invoiceItems,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(name)",
      fn: function fn(data) {
        return [_vm.isReadOnly ? _c('div', [_vm._v(" " + _vm._s(data.item.name) + " ")]) : _c('div', [_c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "12",
            "content-cols-sm": "12"
          }
        }, [_c('b-form-input', {
          model: {
            value: data.item.name,
            callback: function callback($$v) {
              _vm.$set(data.item, "name", $$v);
            },
            expression: "data.item.name"
          }
        }), _c('b-form-invalid-feedback', {
          staticStyle: {
            "margin-bottom": "-16px"
          },
          attrs: {
            "state": !_vm.v$.invoice.invoiceItems.$each.$response.$data[data.index].name.$error
          }
        }, [_vm._v(" 名稱欄位為必填 ")])], 1)], 1)];
      }
    }, {
      key: "cell(unit_price)",
      fn: function fn(data) {
        return [_vm.isReadOnly ? _c('div', [_vm._v(" " + _vm._s(data.item.unit_price) + " ")]) : _c('div', [_c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "12",
            "content-cols-sm": "12"
          }
        }, [_c('b-form-input', {
          model: {
            value: data.item.unit_price,
            callback: function callback($$v) {
              _vm.$set(data.item, "unit_price", $$v);
            },
            expression: "data.item.unit_price"
          }
        })], 1)], 1)];
      }
    }, {
      key: "cell(quantity)",
      fn: function fn(data) {
        return [_vm.isReadOnly ? _c('div', [_vm._v(" " + _vm._s(data.item.quantity) + " ")]) : _c('div', [_c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "12",
            "content-cols-sm": "12"
          }
        }, [_c('b-form-input', {
          model: {
            value: data.item.quantity,
            callback: function callback($$v) {
              _vm.$set(data.item, "quantity", $$v);
            },
            expression: "data.item.quantity"
          }
        })], 1)], 1)];
      }
    }, {
      key: "cell(amount)",
      fn: function fn(data) {
        return [_vm.isReadOnly ? _c('div', [_vm._v(" " + _vm._s(data.item.amount) + " ")]) : _c('div', [_c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "12",
            "content-cols-sm": "12"
          }
        }, [_c('b-form-input', {
          model: {
            value: data.item.amount,
            callback: function callback($$v) {
              _vm.$set(data.item, "amount", $$v);
            },
            expression: "data.item.amount"
          }
        })], 1)], 1)];
      }
    }, {
      key: "cell(processed_memo)",
      fn: function fn(data) {
        return [_vm.isReadOnly ? _c('div', [_vm._v(" " + _vm._s(data.item.processed_memo) + " ")]) : _c('div', [_c('b-form-group', {
          attrs: {
            "label-cols": "12",
            "label-cols-sm": "0",
            "label-size": "sm",
            "content-cols": "12",
            "content-cols-sm": "12"
          }
        }, [_c('b-form-input', {
          model: {
            value: data.item.processed_memo,
            callback: function callback($$v) {
              _vm.$set(data.item, "processed_memo", $$v);
            },
            expression: "data.item.processed_memo"
          }
        })], 1)], 1)];
      }
    }, {
      key: "cell(action)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "d-flex justify-content-center"
        }, [_c('b-button', {
          attrs: {
            "disabled": _vm.isReadOnly,
            "variant": "inverse-danger",
            "size": "sm"
          },
          on: {
            "click": function click() {
              return _vm.deleteInvoiceItem(data.index);
            }
          }
        }, [_vm._v(" 刪除 ")])], 1)];
      }
    }])
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.invoice.invoiceItems.$error
    }
  }, [_vm._v(" 發票明細至少需要一筆資料 ")]), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_vm.isReadOnly && _vm.invoice.invoice_source === 'internal' && _vm.checkPermission([_vm.consts.INVOICE_ISSUE]) ? _c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "primary",
      "disabled": ""
    },
    on: {
      "click": _vm.handleIssue
    }
  }, [_vm._v(" 開立電子發票 ")]) : _vm._e(), _vm.isReadOnly && _vm.invoice.invoice_source === 'internal' && _vm.checkPermission([_vm.consts.INVOICE_CANCEL]) ? _c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "warning",
      "disabled": _vm.invoice.invoice_status !== 'issued'
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v(" 作廢電子發票 ")]) : _vm._e(), _c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goToList
    }
  }, [_vm._v(" " + _vm._s(_vm.isReadOnly ? "返回" : "取消") + " ")]), !_vm.isReadOnly ? _c('b-overlay', {
    staticClass: "d-inline-block",
    attrs: {
      "show": _vm.isSubmmiting,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? "確認修改" : "確認新增") + " ")])], 1) : _vm._e()], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }